import React from "react";
import { HOME } from "@/constants/testIds";
import { Eye, Clock, Flag, Link2, Layers, Workflow } from "lucide-react";

export const WhyTracking = () => {
  const cards = [
    { icon: Eye,      title: "Live Shipment Visibility", body: "See every container's position, status and route — refreshed continuously across carriers and routes." },
    { icon: Clock,    title: "Real-Time ETA Updates",    body: "AI-adjusted ETAs account for port congestion, weather and carrier behaviour. No more stale dates." },
    { icon: Flag,     title: "Milestone Tracking",       body: "From PO to delivery — every milestone is recorded, timestamped and visible to the whole team." },
    { icon: Link2,    title: "Connected Documents",      body: "Bills of lading, packing lists, certificates — attached to the shipment, not buried in inboxes." },
    { icon: Layers,   title: "Operational Context",      body: "Tracking is fused with inventory, purchase orders and warehouse capacity — not isolated." },
    { icon: Workflow, title: "One Workspace",            body: "RFQs, bids, freight, inspection and tracking — one continuous import operating system." },
  ];

  return (
    <section
      id="why"
      data-testid={HOME.whySection}
      className="relative py-24 md:py-32 bg-white border-y border-ink-10"
    >
      <div className="container-narrow">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-[11px] font-mono uppercase tracking-[0.18em] ink-soft mb-4">
              02 — Why Live Shipment Tracking™
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold ink leading-[1.05] text-balance">
              Visibility that drives <span className="text-emerald">decisions</span>, not just dashboards.
            </h2>
          </div>
          <p className="text-[14.5px] ink-soft max-w-md">
            Six capabilities engineered for importers who treat the supply chain as
            an operating system — not a series of email threads.
          </p>
        </div>

        <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {cards.map((c, idx) => {
            const I = c.icon;
            return (
              <li
                key={c.title}
                data-testid={HOME.whyCard}
                className="group relative rounded-2xl bg-[hsl(var(--ivory))] border border-ink-10 p-6 overflow-hidden transition-all hover:translate-y-[-2px] hover:border-[hsla(217,71%,35%,0.35)]"
              >
                <span className="absolute right-5 top-5 text-[10.5px] font-mono ink-soft opacity-60">
                  0{idx + 1}
                </span>
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-white border border-ink-10 text-ink mb-4 group-hover:text-emerald transition-colors">
                  <I className="h-5 w-5" />
                </span>
                <h3 className="font-display text-[17px] font-semibold ink mb-2">{c.title}</h3>
                <p className="text-[13.5px] ink-soft leading-relaxed">{c.body}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
